import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/driving-info/DrivingInfoTrip/.eu';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoTrip/.kr';
import Na from '@di-shared/features/history/driving-info/DrivingInfoTrip/.na';

export interface DrivingInfoTripProps {
  vin: string;
  selectedDate: Date;
  date?: string | null;
  changeDate?: (date: Date | null) => void;
}

export default function DrivingInfoTrip({vin, selectedDate, date, changeDate}: DrivingInfoTripProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
          date={date}
          changeDate={changeDate}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
          /**
           * [2026-03-09:Jeyoung Lee] FIXME: KR도 date query param 추가 필요 (EU와 동일한 로직 적용)
           */
        />
      </Environment.Kr>
      <Environment.Na>
        <Na
          vin={vin}
          selectedDate={selectedDate}
          date={date}
          changeDate={changeDate}
        />
      </Environment.Na>
    </>
  );
}
